import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

interface CancelSubscriptionOptions {
  subscriptionId: string;
  isBaseSubscription?: boolean;
}

export const useCancelSubscription = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (options: CancelSubscriptionOptions | string) => {
      const subscriptionId =
        typeof options === 'string' ? options : options.subscriptionId;
      return subscriptionService.cancelSubscription(subscriptionId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizationSubscription'] });

      // Deliberately no toast and no redirect here.
      //
      // Both used to live in this hook: a success toast followed by
      // `window.location.href = '/organization-suspended'` on a 1.5s timer. The full page
      // load destroyed the toast, and on the way back up StatusChecker found the current
      // organization suspended and auto-switched to another one — so the user was dropped
      // on an ordinary dashboard with no trace that anything had happened, and reasonably
      // concluded the button was broken.
      //
      // The caller now confirms the outcome on screen and navigates when the user
      // acknowledges it. See CancelSubscriptionModal.
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.errors?.[0]?.message ||
          tActionMessages.failedToCancelSubscription,
      );
    },
  });
};
